import { Categories } from "../location/info/category/simple/Categories";

export const CategoryTab = ({ location, locationsIds }: any) => {
    return (
        <Categories locationId={locationsIds} categories={location.categories} />
    );
};